var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 5.99999V8.99999M9.00008 12H9.00758M7.71758 2.14499L1.36508 12.75C1.2341 12.9768 1.1648 13.234 1.16407 13.4959C1.16334 13.7578 1.23119 14.0153 1.3609 14.2429C1.4906 14.4704 1.67762 14.6601 1.90336 14.7929C2.12909 14.9257 2.38568 14.9971 2.64758 15H15.3526C15.6145 14.9971 15.8711 14.9257 16.0968 14.7929C16.3225 14.6601 16.5096 14.4704 16.6393 14.2429C16.769 14.0153 16.8368 13.7578 16.8361 13.4959C16.8354 13.234 16.766 12.9768 16.6351 12.75L10.2826 2.14499C10.1489 1.92457 9.96062 1.74233 9.73597 1.61586C9.51133 1.48938 9.25788 1.42294 9.00008 1.42294C8.74227 1.42294 8.48882 1.48938 8.26418 1.61586C8.03953 1.74233 7.85128 1.92457 7.71758 2.14499Z",
    stroke: "#CD7B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.b871a77ded47546b4f1ba9616151c7d6.svg";
export { ForwardRef as ReactComponent };